
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteProcurement } from '@/services/procurement/deleteProcurementService';
import { toast } from 'sonner';

export const useDeleteProcurement = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteProcurement,
    onSuccess: () => {
      // Invalidate and refetch procurement queries
      queryClient.invalidateQueries({ queryKey: ['procurements'] });
      queryClient.invalidateQueries({ queryKey: ['procurement'] });
      toast.success('Procurement deleted successfully');
    },
    onError: (error: Error) => {
      console.error('Delete procurement error:', error);
      toast.error(error.message || 'Failed to delete procurement');
    },
  });
};
